<template>
  <div class="container-fluid subsortableList">
    <div class="row padding-left-15px margin-top-1Perc">
     <div class="row margin-Top-2Perc">
       <div class="col-xs-3 col-sm-3 col-md-3 col-lg-1 font-size-18px margin-top-7px margin-bottom-15px padding-right-10Px">
          Search
        </div>
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 padding-right-0Px padding-left-0Px">
          <div class="form-group width-90Perc margin-Top-0Point9Perc">
            <div class="icon-addon addon-lg">
              <input type="text" class="form-control background-gray border-rounded" v-model="searchQuery" autocomplete="off"/>
              <label class="glyphicon glyphicon-search"></label>
            </div>
          </div>
        </div>
        <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
        </div>     
      </div> 
    </div>
    <sortable-table-for-sub-links :data="respObj" :columns="columnName" :sortColumns="sortColumns" :filter-key="searchQuery" :linkColumns="linkColumns"></sortable-table-for-sub-links>
  </div>
</template>

<script>
import SortableGridForSubLinks from '@/components/SortableGridForSubLinks'
export default {
  props: ['responseObj', 'sortableColumnName', 'columnNameToShow', 'linkColumnName'],
  created: function () {
    this.setDefaultValues()
  },
  data () {
    return {
      searchQuery: '',
      sortColumns: [],
      columnName: [],
      linkColumns: [],
      respObj: []
    }
  },
  components: {
    'sortable-table-for-sub-links': SortableGridForSubLinks
  },
  name: 'subsortableList',
  computed: {},
  methods: {
    setDefaultValues: function () {
      this.respObj = this.responseObj
      this.sortColumns = this.sortableColumnName
      this.columnName = this.columnNameToShow
      this.linkColumns = this.linkColumnName
    }
  },
  watch: {
    responseObj: function (newVal, oldVal) {
      this.setDefaultValues()
    }
  }
}
</script>
<style scoped>
.padding-left-15px {
  padding-left: 15px !important;
}
.background-gray {
  background-color: #ddd;
}
.margin-Top-0Point9Perc{
  margin-top: 0.9%;
}
.width-90Perc {
  width: 90%;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.padding-right-10Px{
  padding-right: 10px !important;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-top-7px{
  margin-top: 7px !important;
}
margin-top-3px{
  margin-top: 3px !important;
}

.text-align-vertical-center{
  vertical-align: middle;
}
.margin-bottom-15px{
  margin-bottom:15px !important;
}
.text-align-right{
 text-align: right;
}
.text-align-left{
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}
.icon-addon {
  position: relative;
  color: #555;
  display: block;
}
.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}
.icon-addon:after {
  clear: both;
}
.font-size-18px{
    font-size: 18px !important;
}
.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
</style>





// WEBPACK FOOTER //
// src/pages/SubSortableList.vue